import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

const IFRAME_ROUTES = ['/ordering', '/receiving', '/website-preview', '/pos', '/ops', '/tv', '/out-of-stock', '/competitors', '/integrations/mbll', '/website/theme', '/payroll', '/mbll-catalog', '/cockpit'];

export default function Layout() {
  const location = useLocation();
  const isIframe = IFRAME_ROUTES.includes(location.pathname);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-base">
      {/* Desktop sidebar */}
      <div className="hidden md:flex">
        <Sidebar />
      </div>

      {/* Mobile sidebar drawer */}
      {sidebarOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setSidebarOpen(false)}
          />
          <div className="relative w-72 h-full animate-slide-in-left">
            <Sidebar onClose={() => setSidebarOpen(false)} />
          </div>
        </div>
      )}

      <div className="flex-1 flex flex-col overflow-hidden">
        <TopBar onMenuToggle={() => setSidebarOpen(!sidebarOpen)} />
        <main className={`admin-text flex-1 overflow-auto ${isIframe ? '' : 'p-3 md:p-6'} bg-base`}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
